import { ControlDelivery } from "../../../../types/delivery/control-delivery";
import { DeliveryGroupType } from "../../../../types/schedule/delivery-group-type";
import { DeliveryState } from "../../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    deliveryKeys: string[];
  };
}

export const setControlDeliveriesDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { deliveryKeys } = action.payload;
  const controlDeliveriesTemp: ControlDelivery[] = [];
  const splitIndex = state.controlDeliveries.findIndex(
    (controlDelivery) => controlDelivery.type === DeliveryGroupType.Split
  );
  const controlDeliveriesWithoutSplit = state.controlDeliveries.filter(
    (controlDelivery) => controlDelivery.type !== DeliveryGroupType.Split
  );
  deliveryKeys.forEach((deliveryKey) => {
    const controlDeliveryTemp = controlDeliveriesWithoutSplit.find(
      (controlDelivery) => controlDelivery.key === deliveryKey
    );
    if (controlDeliveryTemp) {
      controlDeliveriesTemp.push(controlDeliveryTemp);
    }
  });
  if (splitIndex !== -1) {
    controlDeliveriesTemp.splice(
      splitIndex,
      0,
      state.controlDeliveries[splitIndex]
    );
  }
  state.controlDeliveries = controlDeliveriesTemp;
};
